import { has, debounce } from "lodash";

export const getters = {
    id(state) {
        return state.id;
    },
    form(state) {
        return state.form;
    },
    components(state) {
        return state.form.components;
    },
    name(state) {
        return state.name;
    },
    meta(state) {
        return state.form.meta;
    },
    messages(state) {
        return state.messages;
    },
    emailReceipts(state) {
        return state.emailReceipts;
    },
    issues(state) {
        return state.issues;
    }
};

export const mutations = {
    id(state, id) {
        state.id = id;
    },
    form(state, form) {
        state.form = form;
    },
    components(state, components) {
        state.form.components = components;
    },
    name(state, name) {
        state.name = name;
    },
    meta(state, meta) {
        state.settings = {...state.form.meta, ...meta};
    },
    messages(state, msg) {
        state.messages = {...state.messages, ...msg};
    },
    emailReceipts(state, receipt) {
        state.emailReceipts = {...state.emailReceipts, ...receipt};
    },
    issues(state, issue) {
        state.issues = {...state.issues, ...issue};
    },
};

export const actions = {
    debounceUpdate: debounce(({ dispatch }, form) => {
        if (has(form, 'components')) {
            dispatch('update', form);
        }
    }, ca.config('debounce.wait')),
    update({ commit }, form) {
        commit('components', form.components);
    },
    debounceUpdateName: debounce(({ dispatch }, name) => {
        dispatch('updateName', name);
    }, ca.config('debounce.wait')),
    updateName({ commit }, name) {
        commit('name', name);
    },
    debounceUpdateSetting: debounce(({ dispatch }, setting) => {
        dispatch('updateSetting', setting);
    }, ca.config('debounce.wait')),
    updateSetting({ commit }, setting) {
        commit('meta', setting);
    },
    updateForm({ commit }, form) {
        commit('form', form);
    },
};
